import React from "react";
import TableViewer from "../TableViewer";
import { nanoid } from "nanoid";
import { addTopic, removeTopic } from "../../utils/socket.services";
import HttpServices from "../../utils/Http.services";
import ItemModal from "../../modals/ItemModal";
import RemoveModal from "../../modals/RemoveModal";
import { adminPages } from "../../variables/adminPages";
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from '../../stores/actionsList';
import moment from "moment";
import { buildTableWidgetRequest } from '../../utils/widgetRequests';
import { fakeFormsData } from '../../variables/fakeData';
import { normalizeProcessUserType } from '../../utils/processStageAccess';
import {
    getAdminWidgetPreviewRecords,
    getUserWidgetPreviewRecords,
} from '../../utils/processWidgetData';

class TableWidget extends React.Component {

    state = {
        data: [],
        topicId: nanoid(10),
        limit: 30,
        extraItems:[]
        // showTable:false
    }




    componentDidMount() {
        this.init()
        window.addEventListener('reloadFetchData', this.handleReloadFetchData)
    }

    handleReloadFetchData = () => {
        this.fetchData(true)
    }

    componentDidUpdate(prevProps) {
        if (
            prevProps.widget !== this.props.widget
            || prevProps.widget?.thing !== this.props.widget?.thing
            || prevProps.user?.info?._id !== this.props.user?.info?._id
            || prevProps.viewerUserType !== this.props.viewerUserType
            || prevProps.useFakeData !== this.props.useFakeData
        ) {
            this.init()
        }
    }

    componentWillUnmount() {
        window.removeEventListener('reloadFetchData', this.handleReloadFetchData)
        removeTopic(this.state.topicId, this.props.widget.page, 'admin')
    }

    init() {

        this.setState({ data: [] }, () => {
            // getOneThing({ id: this.props.widget.thing }, (fetchResult, fetchError, status) => {
            //     // console.log(fetchResult)
            //     if (fetchResult) {
            //         this.setState({ thing: fetchResult.info }, () => {


            // let headers = [...this.props.widget.headers]
            // if (Array.isArray(this.props.widget.characteristic)) {
            //     this.props.widget.characteristic.forEach(element => {

            //         headers.push({ key: "data." + element, type: 'TextInput', information: { label: this.getLabel(element) } })

            //     });
            // this.setState({ headers })
            // }

            this.fetchData()
            // })
            //     }
            // })
        })
    }



    openEditModal = (prop, index) => {
        // console.log(prop)
        this.itemModal.modal.showModal()
        this.setState({ currentItem: prop, currentIndex: index })
    }

    openRemoveModal = (prop, index) => {
        this.removeModal.modal.showModal()
        this.setState({ currentItem: prop, currentIndex: index })
    }


    openRefModal = (prop, index, reference) => {
        // console.log("openRefModal")
        // console.log(reference)
        let page = adminPages[reference.ref]

        let _id = typeof prop == 'object' ? prop._id : prop

        let body = { filter: { _id } }

        if (page.page) {
            body.filter = { ...{ page: page.key, _id }, ...body.filter }
        }
        console.log(body)
        HttpServices.request(page.fetchOne, body, (fetchResult, fetchError) => {

            console.log(fetchError)
            if (fetchError) {
                this.props.actions.addNotif({ type: 'error', title: '{{lang}}errors.loadDataFailed', description: fetchError.message })
                return
            }

            let newItem = { page, data: fetchResult.info }
            let extraItems = this.state.extraItems
            extraItems.push(newItem)
            this.setState({ extraItems }, () => {
                setTimeout(() => {
                    this['itemModal' + String(extraItems.length - 1)].modal.showModal()
                }, 10);
            })

        })

    }



    itemAdded = (newItem, modalIndex) => {
        // console.log(newItem)

        if (newItem && modalIndex == null) {
            let data = this.state.data
            data.splice(0, 0, newItem)
            // console.log(newItem)
            // console.log(data)
            this.setState(data)
        } else {
            this.fetchData(true)
        }
    }

    itemEdited = (editedItem, id, modalIndex) => {
        // console.log(editedItem)
        if (modalIndex == null) {
            let data = this.state.data
            this.state.data.forEach((element, index) => {
                let id = element.id ?? element._id
                let currentId = this.state.currentItem.id ?? this.state.currentItem._id
                if (id === currentId) {
                    // console.log(id)
                    data[index] = Object.assign({}, editedItem)
                }
            })
            this.setState({ data }, () => {
                // console.log(editedItem)
                // console.log(data)
                // this.TableViewer.forceUpdateData()
            })
        } else {
            this.fetchData()
        }
    }

    handleRecordUpdated = (updatedRecord) => {
        const updatedId = updatedRecord?._id || updatedRecord?.id
        if (!updatedId) return

        this.setState(previousState => ({
            data: previousState.data.map(record => {
                const recordId = record?._id || record?.id
                return recordId === updatedId ? updatedRecord : record
            }),
        }))
    }


    fetchData = (getCount) => {
        this.setState({ isLoadingData: true });
        const page = this.props.widget
        const additionalFilter = {}

        // Add time filter if specified
        if (this.props.widget.timeFilter) {
            const now = moment()
            let startDate
            
            switch (this.props.widget.timeFilter) {
                case 'week':
                    startDate = now.clone().subtract(1, 'week').startOf('day').valueOf()
                    break
                case 'month':
                    startDate = now.clone().subtract(1, 'month').startOf('day').valueOf()
                    break
                case '3months':
                    startDate = now.clone().subtract(3, 'months').startOf('day').valueOf()
                    break
                case '6months':
                    startDate = now.clone().subtract(6, 'months').startOf('day').valueOf()
                    break
                default:
                    startDate = null
            }
            
            if (startDate) {
                additionalFilter.uDate = { $gte: startDate }
            }
        }

        const body = buildTableWidgetRequest({
            widget: page,
            filter: this.state.filter,
            filter2: this.state.filter2,
            variables: this.props.variables,
            userId: this.props.user?.info?._id,
            currentPage: this.state.currentPage,
            totalCount: this.state.totalCount,
            getCount,
            additionalFilter,
        })

        const viewerUserType = normalizeProcessUserType(this.props.viewerUserType)
        const usePreviewData = this.props.useFakeData
            && ['admin', 'veterinarian', 'horseBreeder'].includes(viewerUserType)

        if (usePreviewData) {
            const previewFrame = body.frame || body.filter?.frame
            const previewFollowUpStatus = body.filter?.['values.lastFollowUpResult']
            const previewSource = fakeFormsData.filter(record => {
                const matchesFrame = !previewFrame
                    || record.frame === previewFrame
                    || record.page === previewFrame
                const matchesFollowUpStatus = !previewFollowUpStatus
                    || record.values?.lastFollowUpResult === previewFollowUpStatus

                return matchesFrame && matchesFollowUpStatus
            })
            const previewData = viewerUserType === 'admin'
                ? getAdminWidgetPreviewRecords({
                    records: previewSource,
                    limit: page.limit ?? 10,
                    sort: page.sort,
                })
                : getUserWidgetPreviewRecords({
                    records: previewSource,
                    userType: viewerUserType,
                    userId: this.props.user?.info?._id,
                    limit: page.limit ?? 10,
                })

            this.setState({
                data: previewData,
                isLoadingData: false,
                showTable: true,
                totalCount: previewData.length,
            })
            return
        }

        HttpServices.request(page.fetchUrl, body, (fetchResult, fetchError) => {
            this.setState({ isLoadingData: false })
            if (fetchError) {
                this.props.actions.addNotif({ type: 'error', title: '{{lang}}errors.loadDataFailed', description: fetchError.message })
                return
            }
            addTopic(this.state.topicId, page.page, 'admin', null, this.updateData)

            this.setState({ data: [], showTable: false }, () => {
                setTimeout(() => {
                    this.setState({ data: fetchResult.info, showTable: true })
                }, 100);
            })

            if (fetchResult.count != null) {
                this.setState({ totalCount: fetchResult.count })
            }
        })
    }






    getLabel(dataObject) {
        // console.log(dataObject)
        if (this.state.thing?.structure) {
            // let result = ''
            for (let i = 0; i < this.state.thing.structure.length; i++) {
                const structure = this.state.thing.structure[i];
                if (structure.dataObject === dataObject) {
                    return structure.label
                }
            }

        }
    }


    updateData = (newData) => {
        // let data = this.state.data
        console.log(newData)
        // data.splice(0, 0, { cDate: new Date(), data: newData })
        // data = { ...data, ...newData }
        // this.setState({ data })
        // console.log("updateData")
    }


    functionsHandler = (prop, index, reference) => {

        if (this[reference.function]) {
            this[reference.function](prop, index, reference)
        }

    }

    openStatusModal = (rowData, index, action) => {
        // Store the row data that should show the status modal
        this.setState({ statusModalRowId: rowData._id || rowData.id }, () => {
            // Trigger a custom event or use a ref to open the modal
            // Since we can't directly access the table component, we'll use a different approach
            // The table component will check for this state via a prop or we'll use a global event
            window.dispatchEvent(new CustomEvent('openStatusModal', { detail: { rowId: rowData._id || rowData.id } }))
        })
    }
    render() {
        return (
            <div className="w-100" style={{ position: 'relative', height: '100%', maxHeight: '100%', overflow: 'hidden', display: 'flex', flexDirection: 'column' }} >
                {this.state.showTable && (
                    <div className="flex-1 no-scrollbar" style={{ position: 'relative', width: '100%', overflow: 'auto', minHeight: 0 }}>
                        <TableViewer
                            isLoading={this.state.isLoadingData}
                            headers={this.props.widget?.headers}
                            data={this.state.data}
                            variables={this.props.variables}
                            viewerUserType={this.props.viewerUserType}
                            onRecordUpdated={this.handleRecordUpdated}
                            top={0}
                            actions={this.props.widget?.actions}
                            // openEditModal={this.openEditModal}
                            openEditModal={this.openEditModal}
                            openStatusModal={this.openStatusModal}
                            sendFinancialEmail={this.sendFinancialEmail}
                            openRemoveModal={this.openRemoveModal}
                            // updateData={this.updateData}
                            functionsHandler={this.functionsHandler}
                        />
                    </div>
                )}


                <ItemModal
                    ref={el => this.itemModal = el}
                    page={this.props.widget}
                    headers={this.props.widget?.headers}
                    initData={this.state.currentItem}
                    variables={this.props.variables}
                    itemAdded={this.itemAdded}
                    itemEdited={this.itemEdited}
                    openRefModal={this.openRefModal}
                    functionsHandler={this.functionsHandler}
                    showDates={true}
                />


                {this.state.extraItems && this.state.extraItems.map((prop, index) => {
                    return (

                        <ItemModal
                            ref={el => this["itemModal" + index] = el}
                            page={prop.page}
                            headers={prop.page?.headers}
                            initData={prop.data}
                            variables={this.props.variables}
                            itemAdded={this.itemAdded}
                            itemEdited={this.itemEdited}
                            openRefModal={this.openRefModal}
                            functionsHandler={this.functionsHandler}

                            showDates={true}
                            modalIndex={index}
                        />

                    )

                })}


                <RemoveModal
                    isLoading={this.state.isLoadingRemove}
                    removeFunction={this.fetchRemove}
                    ref={el => this.removeModal = el}
                />

            </div >
        )
    }
}




const mapStateToProps = state => ({ settings: state.settings, user: state.user })
const mapDispatchToProps = dispatch => ({ actions: bindActionCreators(actions, dispatch) })

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(TableWidget);
